<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main class="main main--has-floating-buttons">
    <card :title="$t('pageReviewSelfCheckInCandidates.card.reservations')" cols="12">
      <hm-card-inner full-size>
        <paginated-table :items-per-page="25"
                         :rows="candidates"
                         :sticky="true"
                         min-width="600px"
                         columns="15">
          <template v-slot:table-head>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.sourceName') }}</div>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.confirmationNumber') }}</div>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.reservationNumber') }}</div>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.roomNumber') }}</div>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.arrivalDate') }}</div>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.departureDate') }}</div>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.name') }}</div>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.numAdults') }}</div>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.numChildren') }}</div>
            <div class="hm-table__th text-right">{{ $t('pageReviewSelfCheckInCandidates.table.total') }}</div>
            <div class="hm-table__th text-right">{{ $t('pageReviewSelfCheckInCandidates.table.balance') }}</div>
            <div class="hm-table__th text-right">{{ $t('pageReviewSelfCheckInCandidates.table.otaCredit') }}</div>
            <div class="hm-table__th text-right">{{ $t('pageReviewSelfCheckInCandidates.table.review') }}</div>
            <div class="hm-table__th text-right">{{ $t('pageReviewSelfCheckInCandidates.table.selfCheckIn') }}</div>
            <div class="hm-table__th text-right">{{ $t('pageReviewSelfCheckInCandidates.table.actions') }}</div>
          </template>
          <template v-slot:default="slotProps">
            <template v-for="row in slotProps.currentPage">
              <div class="hm-table__td privacy--blur" @click="openReservation(row.id)">{{ row.sourceName || hotelSettings.hotel.whiteLabel }}</div>
              <div class="hm-table__td privacy--blur" @click="openReservation(row.id)">{{ row.confirmationNumber }}</div>
              <div class="hm-table__td privacy--blur" @click="openReservation(row.id)">{{ row.reservationNumber }}</div>
              <div class="hm-table__td privacy--blur" @click="openReservation(row.id)">{{ row.roomNumber }}</div>
              <div class="hm-table__td" @click="openReservation(row.id)">{{ row.arrivalDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td" @click="openReservation(row.id)">{{ row.departureDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td privacy--blur" @click="openReservation(row.id)">{{ row.reservationDisplayName }}</div>
              <div class="hm-table__td" @click="openReservation(row.id)">{{ row.numAdults }}</div>
              <div class="hm-table__td" @click="openReservation(row.id)">{{ row.numChildren }}</div>
              <div class="hm-table__td text-right" @click="openReservation(row.id)">{{ (row.totalAmountIncludingTaxes + row.shoppingCartSummaryIncludingTaxes) | toCurrency }}</div>
              <div class="hm-table__td text-right" @click="openReservation(row.id)">{{ row.balance | toCurrency }}</div>
              <div class="hm-table__td text-right" @click="openReservation(row.id)">{{ (row.selfCheckInDetails || {}).expectedOtaRoomAmount | toNullableCurrency }}</div>
              <div v-if="isEmpty((row.selfCheckInDetails || {}).reviewStatus)" class="hm-table__td text-right" @click="openReservation(row.id)">{{ $t(`SelfCheckInReviewStatus.NotSet`) }}</div>
              <div v-else-if="(row.selfCheckInDetails || {}).needsReview === false" class="hm-table__td text-right" @click="openReservation(row.id)">{{ $t(`SelfCheckInReviewStatus.NotRequired`) }}</div>
              <div v-else class="hm-table__td text-right" @click="openReservation(row.id)">{{ $t(`SelfCheckInReviewStatus.${(row.selfCheckInDetails || {}).reviewStatus}`) }}</div>
              <div v-if="(row.selfCheckInDetails || {}).eligibleForSelfCheckIn" class="hm-table__td hm-table__td--icon hm-table__td--icon--no-hover" @click="openReservation(row.id)">
                <span class="icon-wrapper" disabled>
                  <icon v-tooltip="logTooltip(row)" icon="save" />
                </span>
              </div>
              <div v-else class="hm-table__td hm-table__td--icon hm-table__td--icon--no-hover" @click="openReservation(row.id)">
                <span class="icon-wrapper" disabled>
                  <icon v-tooltip="logTooltip(row)" icon="delete" />
                </span>
              </div>
              <div class="hm-table__td hm-table__td--icon">
                <span v-tooltip="{ title: $t('pageReviewSelfCheckInCandidates.actions.updateReservation'), delay: 0, placement: 'left', positionFixed: true, trigger: 'hover', touch: false }"
                      class="quick-action-button"
                      @click="updateReservation(row.id)">
                  <icon icon="refresh" />
                </span>
                <span v-tooltip="{ title: $t('pageReviewSelfCheckInCandidates.actions.approveReservation'), delay: 0, placement: 'left', positionFixed: true, trigger: 'hover', touch: false }"
                      v-if="!isNil(row.selfCheckInDetails) && row.selfCheckInDetails.canOverride && ((row.selfCheckInDetails.needsReview && !['Completed'].includes(row.selfCheckInDetails.reviewStatus)) || !row.selfCheckInDetails.eligibleForSelfCheckIn)"
                      class="quick-action-button"
                      @click="reservationAction(row.id, 'updateEligibility', { eligible: true })">
                  <icon icon="save" />
                </span>
                <span v-tooltip="{ title: $t('pageReviewSelfCheckInCandidates.actions.disapproveReservation'), delay: 0, placement: 'left', positionFixed: true, trigger: 'hover', touch: false }"
                      v-if="!isNil(row.selfCheckInDetails) && row.selfCheckInDetails.canOverride && ((row.selfCheckInDetails.needsReview && !['Completed'].includes(row.selfCheckInDetails.reviewStatus)) || row.selfCheckInDetails.eligibleForSelfCheckIn)"
                      class="quick-action-button"
                      @click="reservationAction(row.id, 'updateEligibility', { eligible: false })">
                  <icon icon="delete" />
                </span>
              </div>
            </template>
          </template>
        </paginated-table>
      </hm-card-inner>
    </card>
    <hm-floating-buttons>
      <hm-floating-button :throttle="15000"
                          icon="refresh"
                          color="orange"
                          label="Update"
                          @click="update" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  get,
  filter,
  last,
  find,
  nth,
  template,
  clone,
  cloneDeep,
  isEqual,
  isObject,
  debounce,
  lowerCase,
  sortBy,
  isNumber,
  isNaN, findIndex, countBy,
} from 'lodash';
import HmCol from '../lib/layout/HmCol';
import HmTable from '../lib/table/HmTable';
import { util } from 'protobufjs/minimal';
import HmCardInner from '../lib/layout/HmCardInner';
import PageMixin from '../../mixins/PageMixin';
import PaginatedTable from '../lib/table/PaginatedTable.vue';
import HmFloatingButton from '../lib/inputs/HmFloatingButton.vue';

export default {
  name: 'PageReviewSelfCheckInCandidates',
  components: { HmFloatingButton, PaginatedTable, HmCardInner, HmCol, HmTable },

  mixins: [HotelmeisterMixin, PageMixin],

  data() {
    return {
      today: this.$moment().format('YYYYMMDD'),
      candidates: [],
    };
  },

  computed: {
    cntByConfirmationNumber() {
      return countBy(this.candidates, 'confirmationNumber');
    },
  },

  watch: {
  },

  created: function () {
    this.init();
  },

  beforeDestroy: function () {
  },

  methods: {
    init() {
      this.axios.get(this.serviceUrls.selfCheckIn.list(this))
        .then((response) => {
          this.candidates = response.data.data;
        });
    },
    update() {
      this.axios.post(this.serviceUrls.selfCheckIn.update(this))
        .then((response) => {
          this.candidates = response.data.data;
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    updateReservation(reservationId) {
      this.reservationAction(reservationId, 'recalculateEligibility');
    },
    reservationAction(reservationId, action, queryParams = null) {
      let url = this.serviceUrls.selfCheckIn[action](this, reservationId);
      if (queryParams) {
        const params = new URLSearchParams(queryParams).toString();
        url += `?${params}`;
      }

      this.axios.post(url)
        .then((response) => {
          const updatedReservation = response.data.data;
          const index = findIndex(this.candidates, { id: updatedReservation.id });
          if (index !== -1) {
            this.$set(this.candidates, index, updatedReservation);
            this.showSuccessMessage();
          }
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    logTooltip(row) {
      const toLocalDateTime = this.$options.filters.toLocalDateTime;
      const logs = ((row.selfCheckInDetails || {}).selfCheckInEventLog || [])
        .slice() // Create a shallow copy of the array
        .reverse() // Reverse the copied array
        .map(log => `${toLocalDateTime(log.timestamp)} - ${log.msg}`)
        .join('<br />');

      if (isEmpty(logs)) return null; // do not show a tooltip at all, instead of an empty one

      return {
        title: () => `<div style="overflow: hidden; white-space: normal; word-wrap: break-word;">${logs}</div>`,
        closeOnClickOutside: true,
        delay: 500,
        theme: 'light',
        placement: 'left',
        trigger: 'hover focus',
        html: true,
        boundariesElement: 'scrollParent',
        preventOverflow: true,
        positionFixed: false,
        container: 'parent',
      };
    },
    openReservation(reservationId) {
      this.$router.push({ name: 'reservation', params: { reservationId: reservationId } });
    }
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  /deep/ .hm-table__td {
    cursor: pointer;
  }
</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageReviewSelfCheckInCandidates.vue